"use client";

import dynamic from "next/dynamic";

function HeroGlobePoster() {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-0 min-h-0 overflow-hidden"
      aria-hidden
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[124%] w-full">
        <div className="size-full min-h-0 hero-globe-poster" aria-hidden />
      </div>
    </div>
  );
}

/**
 * Separate chunk from layout: three.js is not in the shared bundle graph.
 * CSS poster paints before WebGL (LCP can stay text/poster instead of canvas).
 */
const HeroGlobe = dynamic(() => import("./HeroGlobe").then((m) => m.HeroGlobe), {
  ssr: false,
  loading: () => <HeroGlobePoster />,
});

export function HeroGlobeSlot() {
  return <HeroGlobe />;
}
